import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";

import { getTNDSInsurancePrice } from "../../actions/insAct";

import { commonErr } from "../../components/common/errors";

import { TypeRegBox } from "../../components/common/common";

import { LoadingInline } from "../common/loading";
import { MessageBox } from "../common/messagebox";
import { IcInsuranceCar, Tooltip, IcMinusGreenCircle, IcPlusCircle, IcBack } from "../common/svg";

import Header from "../components/header";
import Footer from "../components/footer";
import RegisterBox from "./registerbox";

import pti from "../../static/images/insurance/anonymous/pti.png";

import fourSeat from "../../static/images/vehicle-type/4.png";
import sevenSeat from "../../static/images/vehicle-type/7.png";
import pickupTruck from "../../static/images/vehicle-type/1.png";
import process_1 from "../../static/images/insurance/anonymous/process1.svg";
import process_2 from "../../static/images/insurance/anonymous/process2.svg";
import process_3 from "../../static/images/insurance/anonymous/process3.svg";
import { InsuranceProcess } from "./home";

const REGISTER = {
	BUSSINESS: 2,
	NO_BUSSINESS: 1,
};
const VTYPE = {
	FOUR: 1,
	SEVEN: 2,
	PTRUCK: 7,
};

class TNDSRegister extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			shownTNDS: {},
			step: 1,
			buySeat: true,
			regType: 0,
			vehicleType: 0,
			showPkgPrice: false,
			infoCar: {},
		};

		this.myRef = React.createRef();
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	getTNDSPrice = (regType, vehicleType, buySeat) => {
		const data = {
			regType: regType,
			vehicleType: vehicleType,
			buySeat: buySeat,
		};

		this.props.dispatch(getTNDSInsurancePrice(data));
	};

	getTNDSParams = (buySeat, vehicleType, regType, priceTNDS) => {
		this.setState({
			pkgTNDS: {
				buySeat: buySeat,
				vehicleType: vehicleType,
				regType: regType,
				priceTNDS: priceTNDS,
			},
		});
	};

	onRegTypeChange = (id) => {
		this.setState({
			regType: id,
			showPkgPrice: false,
		});
	};

	onVehicleTypeChange = (id) => {
		this.setState({
			vehicleType: id,
			showPkgPrice: false,
		});
	};

	onBuySeatChange = (buySeat) => {
		this.setState({
			buySeat,
		});
	};

	onBuySeatChangePrice = () => {
		const { regType, vehicleType } = this.state;
		const buySeat = !this.state.buySeat;

		this.setState({
			buySeat,
		});
		this.getTNDSPrice(regType, vehicleType, buySeat);
	};

	isValidInfo = () => {
		const { regType, vehicleType, buySeat } = this.state;

		if (regType === "" || !regType) {
			return "Bạn chưa chọn mục đích sử dụng.";
		}
		if (vehicleType === 0 || !vehicleType) {
			return "Bạn chưa chọn loại xe";
		}
		if (buySeat === undefined) {
			return "Bạn chưa chọn bảo hiểm người ngồi trên xe";
		}
		return "";
	};

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	onSubmit = () => {
		const message = this.isValidInfo();

		if (message !== "") {
			this.setState({
				err: commonErr.FAIL,
				errMsg: message,
			});
			return;
		}

		const { regType, vehicleType, buySeat } = this.state;

		const data = { regType: regType, vehicleType: vehicleType, buySeat: buySeat };

		this.setState({
			infoCar: data,
		});

		this.getTNDSPrice(regType, vehicleType, buySeat);
		this.setState({
			showPkgPrice: true,
		});
	};

	onBuy = () => {
		this.setState({
			step: 2,
		});
		window.scrollTo(0, 0);
	};

	showTNDSBox = () => {
		this.setState({
			isOpenTNDSBox: true,
		});
	};

	hideTNDSBox = () => {
		this.setState({
			isOpenTNDSBox: false,
		});
	};

	toggleExplainTNDS = (i) => {
		let { shownTNDS } = this.state;
		this.setState({
			shownTNDS: {
				...shownTNDS,
				[i]: !shownTNDS[i],
			},
		});
	};

	showRegisterBox = (type) => {
		this.setState({
			isOpenRegisterBox: true,
			type: type,
		});
	};

	hideRegisterBox = (type) => {
		this.setState({
			isOpenRegisterBox: false,
		});
	};

	render() {
		let content;
		const { err, price, discountsTNDS } = this.props.ins;
		const { step, buySeat, regType, showPkgPrice, vehicleType, shownTNDS, type, isOpenRegisterBox, pkgTNDS, infoCar } =
			this.state;

		return (
			<div className="mioto-layout">
				<Header />
				<Helmet>
					<title> Bảo hiểm xe ô tô - Bảo hiểm xe hơi | MIOTO</title>
					<meta name="description" content={`Bảo hiểm thân vỏ, bảo hiểm trách nhiệm, bảo hiểm xe ô tô`} />
				</Helmet>
				<section className="body">
					<div className="insurance-page">
						<div className="step-container space xl">
							<div className="m-container">
								<div className="step-by-step">
									<div className={`step-by-step__item ${step === 1 ? "active" : ""}`}>
										<h5 className="number-step">1</h5>
										<h6 className="title-step">Tìm sản phẩm bảo hiểm</h6>
									</div>
									<div className={`step-by-step__item ${step === 2 ? "active" : ""}`}>
										<h5 className="number-step">2</h5>
										<h6 className="title-step">Thông tin sản phẩm</h6>
									</div>
								</div>
							</div>
						</div>
						{step === 1 && (
							<>
								<div className="m-container space sec">
									<div className="insurance-container">
										<h4>Bảo Hiểm Trách Nhiệm Dân Sự Bắt Buộc</h4>
										<div className="car-info-line option-raido">
											<div className="car-info--title">Mục Đích Sử Dụng {regType === 0 && <span>*</span>}</div>
											<div className="car-info--option">
												<div className="custom-radio">
													<input
														type="radio"
														id="regType2"
														name="regType"
														value={REGISTER.BUSSINESS}
														checked={regType === REGISTER.BUSSINESS}
														onChange={() => this.onRegTypeChange(REGISTER.BUSSINESS)}
													/>
													<label htmlFor="regType2">Kinh doanh</label>
												</div>
												<div className="custom-radio">
													<input
														type="radio"
														id="regType1"
														name="regType"
														value={REGISTER.NO_BUSSINESS}
														checked={regType === REGISTER.NO_BUSSINESS}
														onChange={() => this.onRegTypeChange(REGISTER.NO_BUSSINESS)}
													/>
													<label htmlFor="regType1">Không kinh doanh</label>
												</div>
											</div>
										</div>
										<div className="car-info-line option-raido">
											<div className="car-info--title">Loại Xe {vehicleType === 0 && <span>*</span>}</div>
											<div className="car-info--option">
												<div className="vehicle-types">
													<div className="custom-radio">
														<input
															type="radio"
															id="vehicle-types-1"
															name="vehicle-types"
															value={VTYPE.FOUR}
															checked={vehicleType === VTYPE.FOUR}
															onChange={() => this.onVehicleTypeChange(VTYPE.FOUR)}
														/>
														<label htmlFor="vehicle-types-1">Xe 4-5 chỗ</label>
													</div>
													<div className="custom-radio">
														<input
															type="radio"
															id="vehicle-types-2"
															name="vehicle"
															value={VTYPE.SEVEN}
															checked={vehicleType === VTYPE.SEVEN}
															onChange={() => this.onVehicleTypeChange(VTYPE.SEVEN)}
														/>
														<label htmlFor="vehicle-types-2">Xe 7 chỗ</label>
													</div>
													<div className="custom-radio">
														<input
															type="radio"
															id="vehicle-types-7"
															name="vehicle"
															value={VTYPE.PTRUCK}
															checked={vehicleType === VTYPE.PTRUCK}
															onChange={() => this.onVehicleTypeChange(VTYPE.PTRUCK)}
														/>
														<label htmlFor="vehicle-types-7">Bán tải</label>
													</div>
												</div>
											</div>
										</div>
										<h6 className="ins-mb">Điều khoản bổ sung</h6>
										<div className="car-info-line option-raido">
											<div className="car-info--title">Bảo hiểm người ngồi trên xe</div>
											<div className="car-info--option">
												<div className="custom-radio">
													<input
														type="radio"
														id="buySeat1"
														name="buySeat"
														value={buySeat}
														checked={buySeat}
														onChange={() => this.onBuySeatChange(true)}
													/>
													<label htmlFor="buySeat1">Có</label>
												</div>
												<div className="custom-radio">
													<input
														type="radio"
														id="buySeat0"
														name="buySeat"
														value={buySeat}
														checked={!buySeat}
														onChange={() => this.onBuySeatChange(false)}
													/>
													<label htmlFor="buySeat0">Không</label>
												</div>
											</div>
										</div>
										<div className="d-flex-center">
											<button className="btn btn-primary" onClick={this.onSubmit}>
												Báo phí sản phẩm bảo hiểm
											</button>
										</div>
									</div>
								</div>
								{showPkgPrice && (
									<div className="m-container space sec">
										{this.props.ins.err == commonErr.LOADING ? (
											<LoadingInline />
										) : this.props.ins.err === commonErr.SUCCESS ? (
											<div className="insurance-container">
												<h4>Chọn Gói Bảo Hiểm</h4>
												<div className="d-flex-align-center-wrap ins-mb">
													<div className="title">
														{vehicleType === VTYPE.FOUR
															? "Xe 4 - 5 chỗ"
															: vehicleType === VTYPE.SEVEN
															? "Xe 7 chỗ"
															: "Bán tải"}
													</div>
													<div className="car-tag">
														<p>{regType === REGISTER.BUSSINESS ? "Kinh doanh" : "Không kinh doanh"}</p>
													</div>
												</div>

												<div className="ins-price-container">
													<div className="ins-price-table ins-tnds">
														<div className="price-table-title">
															<div className="title-unit">(Đơn vị tính: VNĐ)</div>
															<div className="title-content">
																<div className="title-header">
																	<h6>Số Tiền Bảo Hiểm</h6>
																</div>
																<div className="title-content--line" />
																<div>
																	<h6 className="ins-mb">Quyền lợi bảo hiểm</h6>
																	<p>
																		<strong>A. Bảo hiểm TNDS Bắt buộc</strong>
																	</p>
																	<div className="custom-checkbox-selected">
																		<input type="checkbox" id="tnds1" name="tnds1" disabled defaultChecked />
																		<label htmlFor="tnds1">Bảo hiểm trách nhiệm cho bên thứ 3</label>
																	</div>
																	{/* <div className="tooltip">
																		<div className="wrap-svg">
																			<Tooltip />
																		</div>
																		<div className="tooltip-text">
																			Nhà bảo hiểm thay mặt chủ xe bồi thường các tổn thất về người và tài sản cho bên
																			thứ ba (bên bị thiệt hai do xe của chủ xe gây ra).
																			<br />
																			Về người: tối đa 150 triệu đồng/người /vụ.
																			<br />
																			Về tài sản: theo tổn thất thực tế, tối đa 100.000.000đ.
																		</div>
																	</div> */}
																	<div className="title-content--space" />
																	<p>
																		<strong>B. Điều khoản bổ sung</strong>
																	</p>
																	<div className="custom-checkbox-selected">
																		<input
																			type="checkbox"
																			id="tnds2"
																			name="tnds1"
																			value={buySeat}
																			checked={buySeat}
																			onChange={this.onBuySeatChangePrice}
																		/>
																		<label htmlFor="tnds2">Bảo hiểm người ngồi trên xe</label>
																	</div>
																	{/* <div className="tooltip">
																		<div className="wrap-svg">
																			<Tooltip />
																		</div>
																		<div className="tooltip-text">
																			Nhà bảo hiểm bồi thường thiệt hại về thân thể đối với lái xe và người được chở
																			trên xe với điều kiện những người này bị tai nạn khi đang ở trên xe, lên xuống xe
																			trong quá trình xe ô tô đang tham gia giao thông. Mức trách nhiệm 10 triệu
																			đồng/người/vụ.
																		</div>
																	</div> */}
																</div>
																<div className="title-content--line" />
																<div>
																	<p>
																		<strong>TỔNG PHÍ</strong>
																	</p>
																	<p className="space-left">10% VAT</p>
																	{discountsTNDS &&
																		discountsTNDS.map((discount, i) => {
																			return (
																				<p className="space-left" key={i}>
																					{discount.name}
																				</p>
																			);
																		})}
																</div>
																<div className="title-content--line" />
																<div>
																	<h6>THÀNH TIỀN</h6>
																	<p>(Đã bao gồm 10% VAT)</p>
																</div>
															</div>
														</div>
														<div className="price-table-detail">
															<div className="ins-partner-title">
																<img loading="lazy" className="ic-mr" src={pti} />
																<h6>BẢO HIỂM PTI</h6>
															</div>
															<div className="price-table-container">
																<div className="price-table-wrap">
																	<div>
																		<div className="price-table-line" />
																		<div className="ins-partner-type">
																			<div className="partner-type-name">Gói 1</div>
																		</div>
																		<div className="ins-partner-price">
																			<NumberFormat
																				value={price.insurancePrice}
																				displayType={"text"}
																				thousandSeparator={" "}
																				decimalSeparator={","}
																			/>
																		</div>
																		<div className="ins-partner-note">/người/vụ</div>
																		<div className="price-table-line" />
																		<div>
																			<h6 />
																			<p />
																			<p>
																				<NumberFormat
																					value={price.requiredPrice}
																					displayType={"text"}
																					thousandSeparator={" "}
																					decimalSeparator={","}
																				/>
																			</p>
																		</div>
																		<div className="price-table-line" />
																		<div>
																			<p />
																			<p className={`${buySeat ? "" : "text-gray"}`}>
																				<NumberFormat
																					value={price.seatPrice.price}
																					displayType={"text"}
																					thousandSeparator={" "}
																					decimalSeparator={","}
																				/>
																			</p>
																		</div>
																		<div className="price-table-line" />
																		<div>
																			<p>
																				<NumberFormat
																					value={price.priceTotal}
																					displayType={"text"}
																					thousandSeparator={" "}
																					decimalSeparator={","}
																				/>
																			</p>
																			<p>
																				<NumberFormat
																					value={price.priceTotalVAT}
																					displayType={"text"}
																					thousandSeparator={" "}
																					decimalSeparator={","}
																				/>
																			</p>
																			{price.discounts &&
																				price.discounts.map((discount, i) => {
																					return (
																						<p key={i}>
																							-
																							<NumberFormat
																								value={discount.price}
																								displayType={"text"}
																								thousandSeparator={" "}
																								decimalSeparator={","}
																							/>
																						</p>
																					);
																				})}
																		</div>
																		<div className="price-table-line" />
																		<div className="price-table-total">
																			<NumberFormat
																				value={price.priceFinal}
																				displayType={"text"}
																				thousandSeparator={" "}
																				decimalSeparator={","}
																			/>
																		</div>
																	</div>
																	<div className="price-table-btn">
																		<div className="btn btn-primary" onClick={() => this.onBuy()}>
																			Chọn Mua
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<p>
													Liên hệ Mioto tại{" "}
													<strong>
														{" "}
														<a className="text-primary" href="tel:19009217">
															1900 9217{" "}
														</a>
													</strong>
													(7AM-10PM) hoặc inbox{" "}
													<strong>
														<a
															className="link-fanpage text-primary"
															target="_blank"
															href="https://www.messenger.com/t/mioto.vn">
															Mioto Fanpage
														</a>
													</strong>{" "}
													nếu bạn cần hỗ trợ !
												</p>
											</div>
										) : (
											<div className="ins-price__sect">
												<div className="ex-container">
													<div className="ins-container">
														<p>Thông tin không phù hợp</p>
													</div>
												</div>
											</div>
										)}
									</div>
								)}
							</>
						)}
						{step === 2 && (
							<>
								<div className="m-container space sec">
									<div className="insurance-container">
										<div className="btn-return pointer" onClick={() => this.setState({ step: 1 })}>
											<div className="wrap-svg">
												<IcBack />
											</div>
										</div>
										<h4 className="ins-notmb">Bản Chào Phí Bảo Hiểm Kết Hợp Xe Ô Tô</h4>
										<p className="textAlign-center">(Đơn vị tính: VNĐ)</p>
										<div className="price-list-container">
											<div className="price-list--green">
												<div className="price-list--wrap">
													<p className="fontWeight-6">Loại Xe</p>
													<p>
														{vehicleType === VTYPE.FOUR
															? "Xe 4 - 5 chỗ"
															: vehicleType === VTYPE.SEVEN
															? "Xe 7 chỗ"
															: "Bán tải"}
													</p>
												</div>
												<div className="price-list--wrap">
													<p className="fontWeight-6">Mục Đích Sử Dụng</p>
													<p>{regType === REGISTER.BUSSINESS ? "Kinh doanh" : "Không kinh doanh"}</p>
												</div>
												<div className="price-list--wrap">
													<p className="fontWeight-6">Thời Hạn Bảo Hiểm</p>
													<p>12 tháng</p>
												</div>
												<div className="price-list--wrap">
													<p className="fontWeight-6">Nhà Bảo Hiểm</p>
													<div className="price-list-ins-partner">
														<img loading="lazy" src={pti} />
														<p>Bảo hiểm PTI</p>
													</div>
												</div>
												<div className="price-list--wrap">
													<p className="fontWeight-6">Số Tiền Bảo Hiểm</p>
													<p>
														<NumberFormat
															value={price.insurancePrice}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>
													</p>
												</div>
											</div>
											<div>
												<div className="price-list--wrap">
													<p className="title">QUYỀN LỢI BẢO HIỂM</p>
													<p className="title">PHÍ BH</p>
												</div>
												<div className="price-list--line" />
												<div className="price-list--wrap">
													<p>Bảo hiểm trách nhiệm cho bên thứ 3</p>
													<p>
														<NumberFormat
															value={price.requiredPrice}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>
													</p>
												</div>
												{buySeat && (
													<div className="price-list--wrap">
														<p>Bảo hiểm người ngồi trên xe</p>
														<p>
															<NumberFormat
																value={price.seatPrice.price}
																displayType={"text"}
																thousandSeparator={" "}
																decimalSeparator={","}
															/>
														</p>
													</div>
												)}
												<div className="price-list--line" />
												<div className="price-list--wrap">
													<p className="fontWeight-6">Tổng Phí Bảo Hiểm TNDS Bắt Buộc</p>
													<p>
														<NumberFormat
															value={price.priceTotal}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>
													</p>
												</div>
												<div className="price-list--wrap">
													<p className="fontWeight-6">Tổng Phí (Gồm 10% VAT)</p>
													<p>
														<NumberFormat
															value={price.priceTotalVAT}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>
													</p>
												</div>
												{discountsTNDS &&
													discountsTNDS.map((discount, i) => (
														<div className="price-list--wrap" key={i}>
															<p className="fontWeight-6">{discount.name}</p>
															{price.discounts &&
																price.discounts.map((discountPrice, j) => (
																	<p key={j}>
																		-
																		<NumberFormat
																			value={discountPrice.price}
																			displayType={"text"}
																			thousandSeparator={" "}
																			decimalSeparator={","}
																		/>
																	</p>
																))}
														</div>
													))}
												<div className="price-list--line" />
												<div className="price-list--wrap">
													<p className="title">Tổng Phí Đã Giảm (gồm 10% VAT)</p>
													<p className="title">
														<NumberFormat
															value={price.priceFinal}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>
													</p>
												</div>
											</div>
										</div>
									</div>
									<div className="ins-sumary-container">
										<div className="price-list--wrap">
											<h6>TỔNG PHÍ</h6>
											<h6>
												<NumberFormat
													value={price.priceFinal}
													displayType={"text"}
													thousandSeparator={" "}
													decimalSeparator={","}
												/>
											</h6>
										</div>
										<div className="price-list--wrap">
											<button
												className="btn btn-blue btn--m"
												onClick={() => this.showRegisterBox(TypeRegBox.INS_NOT_FOUND)}>
												Tôi cần tư vấn thêm
											</button>
											<button
												className="btn btn-primary btn--m"
												onClick={() => this.showRegisterBox(TypeRegBox.BOOKING)}>
												Đặt mua sản phẩm bảo hiểm
											</button>
										</div>
									</div>
								</div>
								<div className="m-container space sec">
									<div className="insurance-container">
										<div className="explain-header">
											<h4>Giải Thích Các Thuật Ngữ Và Điều Khoản</h4>
										</div>
										<div className="ins-explain">
											<div className="ins-explain-wrap active">
												<div className="ins-explain-wrap">
													<div className="wrap-svg ic-mr">
														<IcInsuranceCar />
													</div>
													<h6>Bảo hiểm TNDS bắt buộc</h6>
												</div>
												<div className="wrap-svg">
													<IcMinusGreenCircle />
												</div>
											</div>
											<div className={`ins-explain-item`}>
												<div
													className={`ins-explain-wrap ${shownTNDS[0] ? "active" : ""}`}
													onClick={() => this.toggleExplainTNDS(0)}>
													<div className="ins-explain--title">Bảo hiểm TNDS bắt buộc</div>
													{shownTNDS[0] ? <IcMinusGreenCircle /> : <IcPlusCircle />}
												</div>
												{shownTNDS[0] && (
													<>
														<p>
															Nhà bảo hiểm thay mặt chủ xe bồi thường các tổn thất về người và tài sản cho bên thứ ba
															(bên bị thiệt hai do xe của chủ xe gây ra).
														</p>
														<p>Về người: tối đa 150 triệu đồng/người /vụ.</p>
														<p>Về tài sản: theo tổn thất thực tế, tối đa 100 triệu đồng/vụ.</p>
													</>
												)}
											</div>
											<div className={`ins-explain-item`}>
												<div
													className={`ins-explain-wrap ${shownTNDS[1] ? "active" : ""}`}
													onClick={() => this.toggleExplainTNDS(1)}>
													<div className="ins-explain--title">Bảo hiểm người ngồi trên xe</div>
													{shownTNDS[1] ? <IcMinusGreenCircle /> : <IcPlusCircle />}
												</div>
												{shownTNDS[1] && (
													<>
														<p>
															Nhà bảo hiểm bồi thường thiệt hại về thân thể đối với lái xe và người được chở trên xe với
															điều kiện những người này bị tai nạn khi đang ở trên xe, lên xuống xe trong quá trình xe ô
															tô đang tham gia giao thông.
														</p>
														<p>Mức trách nhiệm 10 triệu đồng/người/vụ.</p>
													</>
												)}
											</div>
										</div>
									</div>
								</div>
								<div className="m-container space sec">
									<div className="insurance-container">
										<h4>Phương Thức Thanh Toán</h4>
										<div className="ins-payment-method">
											<h6>Chuyển khoản qua tài khoản ngân hàng của Mioto:</h6>
											<p>Ngân hàng Vietcombank (Chi nhánh Tân Định)</p>
											<p>Tên tài khoản: CT CP MIOTO ASIA</p>
											<p>Số tài khoản: 102-989-1989</p>
											<p>Nội dung: Thanh toán tiền mua bảo hiểm - Tên chủ xe - SĐT chủ xe</p>
										</div>
									</div>
								</div>
								<div className="insurance-home">
									<InsuranceProcess />
								</div>
							</>
						)}
					</div>
					<MessageBox
						show={this.state.err <= commonErr.SUCCESS}
						hideModal={this.hideMessageBox}
						message={this.state.errMsg}
						error={this.state.err}
					/>
					<RegisterBox isShow={isOpenRegisterBox} hide={this.hideRegisterBox} type={type} infoCar={infoCar} />
				</section>
				<Footer />
			</div>
		);
	}
}

function mapState(state) {
	return {
		ins: state.ins,
	};
}

TNDSRegister = connect(mapState)(TNDSRegister);

export default TNDSRegister;
